import { useEngine, useSyncStatus } from "@heskala/localfirst/react";
import { isOffline } from "@/lib/offline/is-offline";

/**
 * ¿Hay conexión con el servidor? La del motor local-first si está (la misma
 * que usan la franja y la outbox); si no, la señal global de la app (sin
 * suscribirse al WebSocket, ver lib/offline/connection-signal). Para
 * desactivar lo que solo funciona con red (PDF, acciones de fila, scripts).
 */
export function useOnline(): boolean {
  const engine = useEngine();
  const sync = useSyncStatus();
  return engine ? sync.online : !isOffline();
}

/** Sufijo para las acciones que no funcionan sin red. */
export const REQUIRES_CONNECTION = " · requiere conexión";
